var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_c('p',{staticClass:"welcome-text"},[_vm._v("Welcome administrator")]),_c('img',{staticClass:"welcome-img",attrs:{"src":require("assets/images/welcome.png")}})])
}]

export { render, staticRenderFns }